import { useLocation } from 'react-router'

export function useLocationState<
  S extends Record<string, unknown> = Record<string, unknown>,
>(): Partial<S> {
  return (useLocation().state ?? {}) as Partial<S>
}
